<template>
  <div class="account">
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <h3>User account</h3>
      <v-divider></v-divider>
      <div class="formContainer">
        <div v-if="isLoadingData">
          <v-progress-circular
            indeterminate
            :size="20"
            color="blue lighten-5"
            class="mr-2"
          ></v-progress-circular
          >Loading..
        </div>
        <div v-else>
          <div>
            <v-col cols="12" class="formCol">
              <v-text-field
                label="User name"
                v-model="user.UserName"
                :readonly="true"
                :rules="[rules.required]"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </div>
          <div>
            <v-col cols="12" class="formCol">
              <v-text-field
                label="Full name"
                v-model="user.FullName"
                :rules="[rules.required]"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </div>
          <div>
            <v-col cols="12" class="formCol">
              <v-text-field
                label="Email"
                v-model="user.EMail"
                :rules="[rules.required, rules.email]"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </div>
          <div>
            <v-col cols="12" class="formCol">
              <v-text-field
                label="Telephone"
                v-model="user.Telephone"
                :rules="[]"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </div>
          <div>
            <v-col cols="12" class="formCol">
              <v-select
                v-model="user.TFA"
                :items="twoFactorAuthenticationTypes"
                label="Two factor authentication"
                dense
                outlined
              ></v-select>
            </v-col>
          </div>
          <div>
            <v-col cols="12" class="formCol">
              <v-text-field
                  label="Current Password"
                  type="password"
                  v-model="oldPassword"
                  :rules="[rules.required]"
                  dense
                  outlined
                ></v-text-field>
            </v-col>
          </div>
        </div>
      </div>
    </v-form>
    <div class="btnContainer">
      <v-btn depressed color="primary" @click="onSave" class="mr-4" :disabled="!isFormValid"
        >Save account</v-btn
      >
      <v-dialog v-model="dialog" scrollable max-width="500px" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" depressed color="primary" class="mr-4">
            Change password
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Change password</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-7">
            <v-form
              v-model="isChangePasswordFormValid"
              ref="changePasswordForm"
              class="newPasswordForm"
              lazy-validation
            >
              <div class="formRow">
                <v-text-field
                  label="Old password"
                  type="password"
                  v-model="oldPassword"
                  :rules="[rules.required]"
                  dense
                  outlined
                ></v-text-field>
              </div>
              <div class="formRow">
                <v-text-field
                  label="New password"
                  type="password"
                  v-model="newPassword"
                  :rules="[rules.required, rules.minLength]"
                  dense
                  outlined
                ></v-text-field>
              </div>
              <div class="formRow">
                <v-text-field
                  label="Confirm password"
                  type="password"
                  v-model="confirmPassword"
                  :rules="[rules.required, rules.minLength, confirmPasswordRule]"
                  dense
                  outlined
                ></v-text-field>
              </div>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="changePasswordBtnContainer">
            <v-btn outlined color="primary" text @click="onCancelChangePassword"> Cancel </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isChangePasswordFormValid"
              @click="onUpdatePassword"
              class="ml-3"
            >
              Update password
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn depressed color="primary" @click="onOpenGoogleCodeDialog" class="mr-4"
        >Google Code</v-btn
      >

      <v-dialog v-model="googleCodeDialog" scrollable max-width="500px" persistent>
        <v-card>
          <v-card-title>Google Authentication</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-7">
            <div v-if="isLoadingQRcode">
              <v-progress-circular
                indeterminate
                :size="20"
                color="blue lighten-5"
                class="mr-2"
              ></v-progress-circular
              >Loading..
            </div>
            <v-form
              v-else
              v-model="isGoogleCodeFormValid"
              ref="googleCodeForm"
              class="googleCodeForm"
              lazy-validation
            >
              <div class="mb-2">
                Please scan the QRCode below with the Google Authenticator app and then enter the
                code created.
              </div>
              <div class="mb-2">
                <!-- <span>QrCodeSrc = {{ qRCodeSrc }}</span> -->
                <v-img max-height="265" max-width="265" :src="qRCodeSrc"></v-img>
              </div>
              <div class="formRow">
                <v-text-field
                  label="Google code"
                  v-model="googleCode"
                  :rules="[rules.required]"
                  dense
                  outlined
                ></v-text-field>
              </div>
            </v-form>
            <div v-if="showGoogleCodeValidationMessage">
              <v-alert v-if="isGoogleCodeValid" outlined dense type="success"
                >Google code validated successfully</v-alert
              >
              <v-alert v-else outlined dense type="error">Google code not valid</v-alert>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="changePasswordBtnContainer">
            <v-btn outlined color="primary" text @click="onCancelGoogleCode"> Close </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isGoogleCodeFormValid"
              @click="onGoogleCode"
              class="ml-3"
            >
              Check code
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Account',
  created: function () {
    this.getUserData();
  },
  data: () => ({
    isLoadingData: true,
    isLoadingQRcode: true,
    user: null,
    dialog: false,
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
    googleCodeDialog: false,
    googleCode: null,
    isGoogleCodeValid: false,
    showGoogleCodeValidationMessage: false,
    qRCodeSrc: null,
    isFormValid: false,
    isChangePasswordFormValid: false,
    isGoogleCodeFormValid: false,
    twoFactorAuthenticationTypes: ['None', 'Email', 'Google Authenticator'],
    rules: {
      required: (value) => !!value || 'Required.',
      minLength: (value) => (!!value && value.length >= 8) || 'Min 8 characters',
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
      phone: (v) => {
        if (!v) return true;
        else {
          const phoneNumber = v.replace(/ /g, '');
          if (phoneNumber.length == 8 || phoneNumber.length == 11) return true;

          return 'Please enter correct phone number.';
        }
      },
    },
  }),
  computed: {
    userInfo() {
      return this.$store.getters.userInfo ? this.$store.getters.userInfo : null;
    },
    userName() {
      if (this.userInfo) return this.userInfo.UserName;
      else return null;
    },
  },
  watch: {
    userInfo() {
      this.getUserData();
    },
  },
  methods: {
    confirmPasswordRule(value) {
      if (value == this.newPassword) return true;
      else return 'The password confirmation does not match';
    },
    async getUserData() {
      if (this.userName) {
        this.isLoadingData = true;
        try {
          let response = await this.$api.get('/User/GetUser?userName=' + this.userName);

          if (!response.data) {
            const msg = 'Unable to user data';
            this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
            throw new Error(msg);
          }

          this.user = response.data;
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoadingData = false;
        }
      }
    },
    onSave() {
      const isFormValid = this.$refs.form.validate();
      if (isFormValid) this.saveUserAccount();
    },
    onUpdatePassword() {
      const isFormValid = this.$refs.changePasswordForm.validate();
      if (isFormValid) this.updatePassword();
    },
    onCancelChangePassword() {
      this.dialog = false;
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmPassword = null;
    },
    onOpenGoogleCodeDialog() {
      this.googleCodeDialog = true;
      this.getGoogleQRCode();
    },
    onGoogleCode() {
      const isFormValid = this.$refs.googleCodeForm.validate();
      if (isFormValid) this.validateGoogleCode();
    },
    onCancelGoogleCode() {
      this.googleCode = null;
      this.googleCodeDialog = false;
      this.isGoogleCodeValid = false;
      this.showGoogleCodeValidationMessage = false;
    },
    async saveUserAccount() {
      try {
        this.user.OldPassword = this.oldPassword;
        
        await this.$api.post('/User/UpdateUser', this.user);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'User is saved',
        });

        this.oldPassword = null;
      } catch (err) {
        console.error(err);
      }
    },
    async updatePassword() {
      try {
        const model = {
          UserId: this.user.UserId,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
        };
        let response = await this.$api.post('/User/ResetUserPassword', model);
        if (response.data) {
          this.oldPassword = null;
          this.newPassword = null;
          this.confirmPassword = null;
          this.dialog = false;

          this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Password Changed',
        });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getGoogleQRCode() {
      try {
        this.isLoadingQRcode = true;
        let response = await this.$api.get('/User/GenerateQRCode');
        if (response.data) {
          this.qRCodeSrc = response.data;
        } else {
          const msg = 'Unable to load salary list';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingQRcode = false;
      }
    },
    async validateGoogleCode() {
      this.showGoogleCodeValidationMessage = false;
      try {
        let response = await this.$api.get('/User/ValidateGoogleCode', {
          params: { code: this.googleCode },
        });

        this.isGoogleCodeValid = response.data;
        this.showGoogleCodeValidationMessage = true;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.account {
  padding: 0 20px 20px 20px;

  .formContainer {
    margin-top: 25px;
    margin-left: 12px;
    max-width: 400px;

    .formCol {
      padding: 0;
    }
  }
  .btnContainer {
    margin-left: 12px;
  }
}

.newPasswordForm {
  margin-bottom: 10px;
  .formRow {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

.changePasswordBtnContainer {
  justify-content: flex-end;
}
</style>
